import { createElement, forwardRef } from 'react';

import {
  useMonkeysBaseAppearance,
  useMonkeysComponentAttributes,
} from '../../provider/context';
import {
  getBaseTextSizeClassName,
  getBaseTypographyToneClassName,
  resolveBaseAppearance,
} from './theme';
import type { BaseTextProps } from './types';
import { cn } from './utils';

export const BaseText = forwardRef<HTMLElement, BaseTextProps>(function BaseText(
  {
    as = 'p',
    children,
    size = 'md',
    tone = 'default',
    appearance,
    className,
    classNames,
    style,
    ...textProps
  },
  ref,
) {
  const resolvedAppearance = useMonkeysBaseAppearance(appearance);
  const componentAttributes = useMonkeysComponentAttributes();
  const theme = resolveBaseAppearance(resolvedAppearance);

  return createElement(
    as,
    {
      ...componentAttributes,
      ...textProps,
      ref,
      'data-monkeys-component': 'text',
      'data-slot': 'root',
      'data-size': size,
      'data-tone': tone,
      className: cn(
        theme.slots.textRoot,
        getBaseTextSizeClassName(theme, size),
        getBaseTypographyToneClassName(theme, tone),
        classNames?.root,
        className,
      ),
      style: {
        ...theme.styles.text,
        ...style,
      },
    },
    children,
  );
});
